import React from 'react';
import * as Yup from 'yup';

import Input from 'components/Input';
import type { TFunction } from 'i18n/I18nContext';
import { useI18n } from 'i18n/I18nContext';
import { ONBOARD_PASSWORD_MIN_LENGTH } from 'types/onboard';

export interface PasswordFormProps {
  errors?: Partial<Record<string, string>>;
  t?: TFunction;
}

const PasswordForm = ({ errors, t: tProp }: PasswordFormProps) => {
  const { t: tCtx } = useI18n();
  const t = tProp ?? tCtx;

  return (
    <div className="gb-onboard-step">
      <header className="gb-onboard-intro">
        <h1 className="gb-onboard-panel__title">{t('forms.passwordTitle')}</h1>
        <p className="gb-onboard-panel__lede-text">{t('forms.passwordLede')}</p>
      </header>

      <div className="gb-onboard-fields">
        <Input
          label={t('forms.password')}
          type="password"
          name="password"
          autoComplete="new-password"
          hint={t('forms.passwordHint')}
          error={errors?.password}
          revealToggle
        />
      </div>
    </div>
  );
};

function validationSchema(_values: unknown, t: TFunction) {
  return Yup.object().shape({
    password: Yup.string()
      .min(ONBOARD_PASSWORD_MIN_LENGTH, t('forms.valPasswordMin'))
      .required(t('forms.valPasswordRequired')),
  });
}

const PasswordFormExport = PasswordForm as typeof PasswordForm & {
  validationSchema: typeof validationSchema;
};
PasswordFormExport.validationSchema = validationSchema;

export default PasswordFormExport;



// WEBPACK FOOTER //
// ./src/components/forms/PasswordForm.tsx